import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'

/**
 * Select booking status
 */
export const selectBookingStates = createSelector(
  (state: RootState) => state,
  (state) => state.booking
)
